import { StrictLocalizeFunction } from "@faire/web/common/localization";

import {
  COOK_AT_HOME_URL_ID,
  COZY_APPAREL_URL_ID,
  FAMILY_TIME_URL_ID,
  FREE_RETURN_URL_ID,
  SELF_CARE_URL_ID,
  WORK_FROM_HOME_URL_ID,
} from "@faire/retailer/services/Categories";

export const subheaderForLoggedInUsers = (
  strictLocalize: StrictLocalizeFunction
): { [key: string]: string } => ({
  [COOK_AT_HOME_URL_ID]: strictLocalize({
    defaultMessage: "From cookware to pantry staples",
    description: { text: "[subtitle] collection of products to cook at home" },
  }),
  [FAMILY_TIME_URL_ID]: strictLocalize({
    defaultMessage: "Great for kids and pets",
    description: {
      text: "[subtitle] collection of products for kids and pets",
    },
  }),
  [SELF_CARE_URL_ID]: strictLocalize({
    defaultMessage: "Destress and indulge",
    description: { text: "[subtitle] collection of products for self care" },
  }),
  [WORK_FROM_HOME_URL_ID]: strictLocalize({
    defaultMessage: "Make WFH a little more comfortable",
    description: {
      text: "[subtitle] collection of products to help working from home",
    },
  }),
  [COZY_APPAREL_URL_ID]: strictLocalize({
    defaultMessage: "Comfy gear for staying home",
    description: { text: "[subtitle] collection of comfortble apparel" },
  }),
  [FREE_RETURN_URL_ID]: strictLocalize({
    defaultMessage:
      "For a limited time only, try new products from brands you already know—risk-free.",
    description: {
      text: "[subtitle] products eligible for free return on reordering",
    },
  }),
});
